/**
 * Client-side mirrors of the server's upload limits.
 *
 * Mirrors, not the source of truth — the server enforces these independently
 * (apps/backend/src/common/upload-limits.ts). Their job here is to stop the
 * consumer selecting twenty-one files and learning about it only after the
 * upload, not to be the guard.
 */
export const MAX_FILES_PER_BULK_UPLOAD = 20;
